<div class="redirect-interstitial-page">
  <div class="redirect-interstitial-logo">
    <img
      src="assets/irembo-andela/irembogov3-common/images/logo-dark.svg"
      alt="IremboGov"
      height="28" />
  </div>

  <div class="redirect-interstitial-content">
    <div *ngIf="loading" class="text-center">
      <h2 class="redirect-interstitial-title">
        {{ 'You are being redirected' | translate }}
      </h2>
      <p class="redirect-interstitial-description">
        {{
          'This application was submitted through the previous version of IremboGov. You are now being redirected there to continue your application.'
            | translate
        }}
      </p>
      <div class="redirect-interstitial-spinner">
        <svg class="redirect-spinner" viewBox="0 0 50 50">
          <circle
            class="redirect-spinner-path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="4"></circle>
        </svg>
      </div>
    </div>

    <div *ngIf="!loading && error" class="text-center">
      <h2 class="redirect-interstitial-title">
        {{ 'Redirect failed' | translate }}
      </h2>
      <p class="redirect-interstitial-error">{{ error }}</p>
      <button class="btn btn-primary mt-3" (click)="backEvent.emit()">
        {{ 'Go back' | translate }}
      </button>
    </div>
  </div>
</div>
